import * as React from "react";
import translate from "../../translations/i18n";
import "./highfive.css";
import "../../style/fonts.css";
import config from "../../firebase/config.json";

import firebase from "firebase/app";

import clickHere1x from "../../icons/high_five_click_here.png";
import clickHere2x from "../../icons/high_five_click_here@2x.png";
import clickHere3x from "../../icons/high_five_click_here@3x.png";

import hand_back from "../../icons/hand_back.svg";
import hand_front from "../../icons/hand_front.svg";

export interface Props {
  highfiveCurrent: number;
  uid: any;
  profile?: any;
}

interface State {
  highfive: number;
  firestoreHighfives: number;
  timer: NodeJS.Timeout | undefined;
}

class HighFive extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      highfive: 0,
      firestoreHighfives: this.props.highfiveCurrent,
      timer: undefined,
    };
    this.highfive = this.highfive.bind(this);
  }

  highfive() {
    this.setState({highfive: this.state.highfive + 1});
    if (this.state.timer) {
      clearTimeout(this.state.timer);
    }
    const newTimer = setTimeout(() => {
      const newHighfives = this.state.highfive;
      this.setState({
        highfive: 0,
        firestoreHighfives: this.state.firestoreHighfives + newHighfives,
      });

      firebase.analytics().logEvent("highfive_clicked");
      fetch(
        "https://europe-west1-" +
          config.projectId +
          ".cloudfunctions.net/highfives",
        {
          method: "POST",
          body: JSON.stringify({
            $uid: this.props.uid,
            number: newHighfives,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }, 5000);
    this.setState({timer: newTimer});
  }

  updateUsername() {
    if (this.props.profile) return this.props.profile.username;
    else return "";
  }

  componentDidUpdate() {
    if (this.state.firestoreHighfives < this.props.highfiveCurrent) {
      this.setState({firestoreHighfives: this.props.highfiveCurrent});
    }
  }

  render() {
    return (
      <div className="Highfive_box">
        <div className="Highfive_box_inner">
          <div className="HIGHFIVE_GENERAL" onClick={this.highfive}>
            <div className="HIGHFIVE_TEXT_CONTAINER">
              <div className="HIGHFIVE_TEXT_1">
                <div className="TITLE_4" style={{letterSpacing: 1.5}}>
                  {translate("HIGHFIVE_CARD_TITLE_1").toUpperCase()}
                </div>
              </div>
              <div className="HIGHFIVE_TEXT_2">
                <div className="HIGHFIVE_CUSTOM_TEXT_STYLE">
                  {translate("HIGHFIVE_CARD_TITLE_2")}
                </div>
              </div>
              <div className="HIGHFIVE_TEXT_3">
                <div className="TITLE_4">
                  {translate("HIGHFIVE_CARD_TITLE_3", {
                    username: this.updateUsername(),
                  }).toUpperCase()}
                </div>
              </div>
              <div className="HANDS">
                <div className="HAND_BACK transform">
                  <img src={hand_back} />
                </div>
                <div className="HAND_FRONT transform2">
                  <img src={hand_front} />
                </div>
              </div>
              <div className="HIGHFIVE_CLICK_HERE">
                <img
                  src={clickHere1x}
                  srcSet={`${clickHere1x} 1x, ${clickHere2x} 2x, ${clickHere3x} 3x`}
                />
              </div>
              <div className="HIGHFIVE_NUM">
                <div className="TITLE_1_HIGHFIVE">
                  {this.state.highfive + this.state.firestoreHighfives}
                </div>
              </div>
              <div className="HIGHFIVE_TEXT_4">
                <div className="TITLE_3">{translate("HIGHFIVES")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HighFive;



// WEBPACK FOOTER //
// ./src/components/HighFive/highfive.tsx